"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.list = list;
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const adapter_core_1 = require("@aws-amplify/core/internals/adapter-core");
const list_1 = require("../internal/list");
function list(contextSpec, input) {
    return (0, list_1.list)((0, adapter_core_1.getAmplifyServerContext)(contextSpec).amplify, input ?? {});
}
